/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI contexts
import { useArgonController } from "context";

function DetailedStaticsCard({ bgColor, title, count, percentage, icon, direction }) {
    const [controller] = useArgonController();
    const { darkMode } = controller;

    return (
        <Card>
            <ArgonBox
                bgColor={bgColor === "white" && darkMode ? "transparent" : bgColor}
                // bgColor={bgColor}
                variant={bgColor === "white" && darkMode ? "contained" : "gradient"}
            >
                <ArgonBox p={2}>
                    <Grid container>
                        <Grid item xs={8}>
                            <ArgonBox ml={direction === "left" ? 2 : 0} lineHeight={1}>
                                <ArgonTypography
                                    variant="button"
                                    color={bgColor === "white" ? "text" : "white"}
                                    textTransform="uppercase"
                                    fontWeight="medium"
                                >
                                    {title}
                                </ArgonTypography>
                                <ArgonTypography
                                    variant="h5"
                                    fontWeight="bold"
                                    color={bgColor === "white" ? "dark" : "white"}
                                    mb={1}
                                >
                                    {count}
                                </ArgonTypography>
                            </ArgonBox>
                        </Grid>
                        <Grid item xs={4}>
                            {/* <ArgonBox
                                variant="gradient"
                                bgColor={bgColor === "white" ? icon.color : "white"}
                                color={bgColor === "white" ? "white" : "dark"}
                                width="3rem"
                                height="3rem"
                                borderRadius="section"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                ml="auto"
                            > */}
                                <ArgonBox
                                    fontSize="5rem"
                                    display="grid"
                                    placeitems="center"
                                    color={icon.color}
                                    position="absolute"
                                    marginRight="1rem"
                                    right="0"
                                    top="1"
                                    opacity={0.2}
                                >
                                    {icon.component}
                                </ArgonBox>
                            {/* </ArgonBox> */}
                        </Grid>
                    </Grid>
                    {
                        percentage &&
                        <ArgonTypography
                            display="flex"
                            alignItems="center"
                            variant="button"
                            fontWeight="bold"
                            color={percentage.color}
                        >
                            {percentage.count}
                            <ArgonTypography
                                variant="body2"
                                fontWeight="regular"
                                color={bgColor === "white" ? "text" : "white"}
                                ml={0.5}
                                mt={-0.125}
                            >
                                {percentage.text}
                            </ArgonTypography>
                        </ArgonTypography>
                    }
                </ArgonBox>
            </ArgonBox>
        </Card>
    );
}

// Setting default values for the props of DetailedStaticsCard
DetailedStaticsCard.defaultProps = {
    bgColor: "white",
    percentage: {
        color: "success",
        count: '',
        text: "",
    },
    direction: "right",
};

// Typechecking props for the DetailedStaticsCard
DetailedStaticsCard.propTypes = {
    bgColor: PropTypes.oneOf([
        "transparent",
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
    ]),
    title: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    percentage: PropTypes.shape({
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "dark",
            "white",
        ]),
        count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        text: PropTypes.string,
    }),
    icon: PropTypes.shape({
        color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
        component: PropTypes.node.isRequired,
    }).isRequired,
    // direction: PropTypes.oneOf(["right", "left"]),
};

export default DetailedStaticsCard;
